import { COMPLAINT_TOGGLE, ComplaintToggleAction } from 'mk2/containers/Complaint/Complaint.actions';
import { complaintKey } from 'mk2/containers/Complaint/Complaint.schemas';

export interface ComplaintState {
    [entitySlashId: string]: OneComplaintState;
}

interface OneComplaintState {
    show: boolean;
}

const reducer = (state: ComplaintState = {}, action: ComplaintToggleAction) => {
    switch (action.type) {
        case COMPLAINT_TOGGLE:
            const key = complaintKey(action.entity, action.id);
            const complaintState: OneComplaintState = state[key] || { show: false };

            // Just toggle current state if opened is undefined
            complaintState.show = action.opened === undefined ? !complaintState.show : action.opened;

            return {
                ...state,
                [key]: complaintState,
            };
        default:
            return state;
    }
};

export default reducer;

export const getShow = (state: ComplaintState, entity: string, id: number): boolean => {
    const key = complaintKey(entity, id);
    return state[key] ? state[key].show : false;
};
